<template>
  <div class="promotions page">
    <div class="page-header">
      <div class="container">
        <h1 class="title">{{ title }}</h1>
      </div>
    </div>
    <div class="page-body" v-loading="loading">
      <div class="container">
        <el-row v-for="(promotion, index) in promotions" :key="index">
          <div class="promotion-box">
            <div class="promotion-col">
              <div class="promotion-poster">
                <img :src="promotion.promotion_image ? promotion.promotion_image.path : ''" />
              </div>
            </div>
            <div class="promotion-col">
              <div class="promotion-body">
                <h1 class="title">{{ promotion.name }}</h1>
                <span class="text date">Date: {{ promotion.date }}</span>
                <span class="text">{{ promotion.description }}</span>
                <el-button v-if="promotion.url" class="orange-button" @click="onProceedClick(promotion.url)">
                  {{ $t('button.proceed') }}
                </el-button>
              </div>
            </div>
          </div>
        </el-row>
        <el-row v-if="!parseInt(id)" type="flex" justify="center">
          <el-button v-if="!nomore" class="orange-button" @click="onLoadMoreClick()">
            {{ $t('button.loadmore') }}
          </el-button>
          <span v-else>{{ $t('error.nopromotions') }}</span>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Site from '@/api/site'
export default {
  name: 'faq',
  components: {
  },
  props: {
    id: {
      default: undefined
    }
  },
  watch: {
    id () {
      this.onLoad(this.id, true)
      // location.reload()
    }
  },
  data () {
    return {
      limit: 8,
      nomore: false,
      loading: true,
      isCompleted: false,
      isError: false,
      title: '',
      promotions: [],
      lastId: undefined
    }
  },
  mounted () {
    this.onLoad(this.id, false)
  },
  destroyed () {
    this.promotions = undefined
  },
  methods: {
    // implement infinite method
    onLoad (id, reload) {
      if (parseInt(id)) {
        this.getPromotionById(id)
      } else {
        this.promotions = []
        this.getPromotions()
      }
    },
    getPromotionById (id) {
      this.loading = true
      Site.getPromotionById(id).then((res) => {
        this.promotions = []
        let val = res.result
        const start = this.$moment(val.start_date + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY')
        const end = this.$moment(val.end_date + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY')
        val.date = start + ' to ' + end
        this.promotions.push(val)
        this.title = val.name

        this.loading = false
        this.isCompleted = true
      }).catch((err) => {
        this.loading = false
        this.isCompleted = true
        this.isError = true
        console.log(err)
      })
    },
    getPromotions () {
      this.loading = true
      this.title = this.$t('pagetitle.promotions')
      const data = { limit: this.limit, min: this.lastId }
      Site.getPromotions(data).then((res) => {
        res.result.forEach((val) => {
          const start = this.$moment(val.start_date + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY')
          const end = this.$moment(val.end_date + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY')
          val.date = start + ' to ' + end
          this.promotions.push(val)
          this.lastId = val.id
        })
        if (res.result.length < 1) {
          this.nomore = true
        }
        this.loading = false
        this.isCompleted = true
      }).catch((err) => {
        this.loading = false
        this.isCompleted = true
        this.isError = true
        console.log(err)
      })
    },
    onProceedClick (url) {
      window.location.href = url
    },
    onLoadMoreClick () {
      this.getPromotions()
    }
  }
}
</script>
<style lang="scss" scoped>
.promotions {
  .page-body {
    .container {
      padding: 50px 0;
    }
  }
  .promotion-box {
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
    padding-bottom: 30px;

    & > .promotion-col {
      width: 100%;
      @media (min-width: 768px) {
        width: 50%;
      }

      .promotion-poster {
        @media (min-width: 768px) {
          padding-right: 25px;
        }
        & >img {
          width: 100%;
        }
      }
      .promotion-body {
        @media (min-width: 768px) {
          padding-left: 25px;
        }
        & > span {
          display: block;
          padding-bottom: 25px;
        }
        .orange-button {
          letter-spacing: normal;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/promotions/index.vue